// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_jq-0";
export var fileCarousel = "_jq-2";
export var removeFileButton = "_jq-1";